import React, { useState, useEffect } from 'react';
import { Pie, Line, Bar, HorizontalBar,} from 'react-chartjs-2';

import { GMMain } from './MasterDynamicTable.style';

import ReactWordcloud from 'react-wordcloud';

import Chart from "react-google-charts";
import TableSentimientoEdadIngreso from '../Table/TableSentimientoEdadIngreso';
import TableSentimientoEdadRegion from '../Table/TableSentimientoEdadRegion';
import TableSentimientoRegionIngreso from '../Table/TableSentimientoRegionIngreso';
import TableSentimientoSexoEdad from '../Table/TableSentimientoSexoEdad';
import TableSentimientoSexoIngreso from '../Table/TableSentimientoSexoIngreso';
import TableSentimientoSexoRegion from '../Table/TableSentimientoSexoRegion';
import TableTrendEdadIngreso from '../Table/TableTrendEdadIngreso';
import TableTrendEdadRegion from '../Table/TableTrendEdadRegion';
import TableTrendRegionIngreso from '../Table/TableTrendRegionIngreso';
import TableTrendSexoEdad from '../Table/TableTrendSexoEdad';
import TableTrendSexoIngreso from '../Table/TableTrendSexoIngreso';
import TableTrendSexoRegion from '../Table/TableTrendSexoRegion';

const MasterDynamicTable = (props) => {
  let { data, special } = props;
  
  
  let checkGraphKind = (type) => {
    let labelArray = [];
    let labelArrayVar2 = [];
    let labelArrayCombined = [];
    let dataArray = [];
    let dataArray2 = [];
    let dataArray3 = [];
    let price_new = null;
    let verde = [];
    let amarillo = [];
    let rojo = [];
    let price_list = [];
    let mapData = null;
    let mapData2 = null;
    let Conteo = null;
    let mapInfo = {};
    let mapInfo2 = {};
    let mapInfo3 = {};
    let mapInfo4 = {};
    let word = {}
    let data = null; 
    let options = null; 
    let limit = 8
    let getMapData = null;
    if(type){
      switch(type.name) {
          case 'SentimientoProm_EdadIngreso':
            return <TableSentimientoEdadIngreso data={type.data} />
          case 'SentimientoProm_EdadRegion':
            return <TableSentimientoEdadRegion data={type.data} />
          case 'SentimientoProm_RegionIngreso':
            return <TableSentimientoRegionIngreso data={type.data} />
          case 'SentimientoProm_SexoEdad':
            return <TableSentimientoSexoEdad data={type.data} />
          case 'SentimientoProm_SexoIngreso':
            return <TableSentimientoSexoIngreso data={type.data} />
          case 'SentimientoProm_SexoRegion':
            return <TableSentimientoSexoRegion data={type.data} />
          case 'Trend_EdadIngreso':
            return <TableTrendEdadIngreso data={type.data} />
          case 'Trend_EdadRegion':
            return <TableTrendEdadRegion data={type.data} />
          case 'Trend_RegionIngreso':
            return <TableTrendRegionIngreso data={type.data} />
          case 'Trend_SexoEdad':
            return <TableTrendSexoEdad data={type.data} />
          case 'Trend_SexoIngreso':
            return <TableTrendSexoIngreso data={type.data} />
          case 'Trend_SexoRegion':
            return <TableTrendSexoRegion data={type.data} />
        default:
          break;
        }
    }else {
      return <div>No hay información</div>
    }
  }
  
  return (
    <GMMain>
      { checkGraphKind(data) }
    </GMMain>
  );
}

  export default MasterDynamicTable;